/*
  src/redux/callAPI.js

  Created by erikchristensen on 10/19/2016.
  Copyright © 2016 myNfo. All rights reserved.
*/

import Promise from 'bluebird';

import {
  API_URL,
  UPDATE_LATENCY
} from '../../config';

import {
  TOKEN_INVALIDATED as AUTH_TOKEN_INVALIDATED
} from './auth/constants';

import {
  TOKEN_INVALIDATED as IMPERSONATE_TOKEN_INVALIDATED
} from './impersonate/constants';

import values from 'lodash/values';
import flattenDeep from 'lodash/flattenDeep';

import {
  AuthorizationError,
  AuthenticationError,
  ImpersonationError,
  RequestError,
  ServerError,
  NotFoundError
} from './errors/types';

// callAPI({
//   method:'GET',
//   path:'/foo',
//   begin:{
//     type:FOO_REQUESTED,
//   },
//   success:{
//     type:FOO_LOADED,
//     payload:(res) => res.data,
//     result:(res) => res.data
//   },
//   failure:{
//     type:FOO_FAILED_TO_LOAD
//   }
// })


function checkStatusOfRequestUsingToken(requestId,token){
  return fetch(`${API_URL}/sys/v1/command/status?id=${requestId}`,{
    headers:{
      'Authorization':'Bearer '+token
    }
  })
    .then((res) => res.json())
    .then((res) => values(res).map((domains) => values(domains).map((events) => values(events))))
    .then((eventStatuses) => flattenDeep(eventStatuses).every((status) => status !== 'failed'));
}


export default function callAPI(options){
  return function(dispatch,getState){
    const token = options.impersonate ? getState().impersonate.token : getState().auth.token;

    if(!token && options.impersonate && !options.public){
      dispatch({
        type:IMPERSONATE_TOKEN_INVALIDATED
      });
      return Promise.reject();
    }

    if(!token && !options.impersonate && !options.public){
      dispatch({
        type:AUTH_TOKEN_INVALIDATED
      });
      return Promise.reject();
    }

    dispatch({
      type:options.begin.type,
      payload:options.begin.payload(getState())
    });
    
    const headers = new Headers();
    headers.append('Content-Type','application/json; charset=UTF-8');
    headers.append('Accept','application/json');
    
    if(!options.public){
      headers.append('Authorization','Bearer '+token);
    }

    return fetch(API_URL+options.path,{
      method:options.method || 'GET',
      body:options.body ? JSON.stringify(options.body) : undefined,
      headers:headers
    })
      .then((res) => {
        if(options.allow404 && res.status === 404){
          return res.json();
        }

        if(options.allow403 && res.status === 403){
          return res.json();
        }

        if(res.status === 404) throw new NotFoundError();
        if(res.status === 400) throw new RequestError();
        if(res.status === 403) throw new AuthenticationError();
        if(res.status === 401 && options.impersonate) throw new ImpersonationError();
        if(res.status === 401 && !options.impersonate) throw new AuthenticationError();
        if(!res.ok) throw new ServerError();

        return res.json();
      })
      .then((result) => {
        return new Promise((resolve) => {
          if(!options.method || options.method === 'GET' || options.skipTimeout){
            resolve(result);
          } else {
            window.setTimeout( () => {
              resolve(result);
            },UPDATE_LATENCY);
          }
        });
      })
      .then((result) => {
        return new Promise((resolve,reject) => {
          if(!options.waitForConfirmation){
            resolve(result)
          }else{
            checkStatusOfRequestUsingToken(result.requestId,token)
              .then((success) => {
                if(!success){ 
                  reject(new Error('Action failed to resolve'));
                } else {
                  resolve(result);
                }
              })
              .catch((err) => reject(err));
          }
        })
      })
      .then((res) => {
        dispatch({
          type:options.success.type,
          payload:options.success.payload ? options.success.payload(res,getState()) : res
        });

        if(options.success.result){
          return options.success.result(res,getState());
        } else if(options.success.payload){
          return options.success.payload(res,getState());
        } else {
          return res;
        }
      })
      .catch((err) => {
        dispatch({
          type:options.failure.type,
          payload:err,
          error:true
        });

        throw err;
      });
  }
}



// WEBPACK FOOTER //
// ./src/shared/redux/callAPI.js